export type TemplateTokenOption = {
  name: string
  label: string
  value: string
  group: "Empfänger" | "Termin" | "Auftrag" | "Betrieb" | "Links" | "Objekt"
  description: string
  example?: string
  selectable?: boolean
}

const tokenCatalog = {
  organization_name: {
    name: "Betriebsname",
    label: "Betriebsname",
    value: "organization_name",
    group: "Betrieb",
    description: "Fügt den öffentlichen Namen Ihres Betriebs ein.",
    example: "Schornsteinfegerbetrieb Muster",
  },
  organization_email: {
    name: "Betriebs-E-Mail",
    label: "Betriebs-E-Mail",
    value: "organization_email",
    group: "Betrieb",
    description: "Fügt die E-Mail-Adresse ein, über die Kunden Ihren Betrieb erreichen sollen.",
    example: "info@example.de",
  },
  organization_phone: {
    name: "Betriebs-Telefon",
    label: "Betriebs-Telefon",
    value: "organization_phone",
    group: "Betrieb",
    description: "Fügt die Telefonnummer ein, über die Kunden Ihren Betrieb erreichen sollen.",
    example: "+49 30 123456",
  },
  service_number: {
    name: "Servicenummer",
    label: "Servicenummer",
    value: "service_number",
    group: "Betrieb",
    description: "Fügt die Telefonnummer aus dem Servicekontakt ein.",
    example: "+49 30 123456",
  },
  service_email: {
    name: "Service-E-Mail",
    label: "Service-E-Mail",
    value: "service_email",
    group: "Betrieb",
    description: "Fügt die E-Mail-Adresse aus dem Servicekontakt ein.",
    example: "termin@example.de",
  },
  property_address_no_country: {
    name: "Liegenschaftsadresse",
    label: "Liegenschaftsadresse",
    value: "property_address_no_country",
    group: "Objekt",
    description: "Fügt die Adresse der Liegenschaft ein, ohne Deutschland am Ende.",
    example: "Musterstraße 1, 12345 Musterstadt",
  },
  property_address: {
    name: "Adresse vollständig",
    label: "Adresse vollständig",
    value: "property_address",
    group: "Objekt",
    description: "Fügt die vollständige Adresse der Liegenschaft ein.",
    example: "Musterstraße 1, 12345 Musterstadt, Deutschland",
  },
  target_unit_phrase: {
    name: "Zieleinheit",
    label: "Zieleinheit",
    value: "target_unit_phrase",
    group: "Objekt",
    description: "Fügt passend zum Auftrag ‚Ihrem Gebäude‘ oder ‚Ihrer Wohnung‘ ein.",
    example: "Ihrem Gebäude",
  },
  response_deadline_phrase: {
    name: "Rückmeldefrist",
    label: "Rückmeldefrist",
    value: "response_deadline_phrase",
    group: "Termin",
    description:
      "Fügt die Rückmeldefrist ein, zum Beispiel ‚spätestens bis zum 09.09.2026‘. Ohne Termin wird ‚den Termin‘ eingesetzt.",
    example: "spätestens bis zum 09.09.2026",
  },
  letter_greeting: {
    name: "Briefanrede",
    label: "Briefanrede",
    value: "letter_greeting",
    group: "Empfänger",
    description: "Fügt eine passende Anrede ein, wenn der Ansprechpartner eindeutig bekannt ist.",
    example: "Guten Tag Frau Muster,",
  },
  customer_name: {
    name: "Empfängername",
    label: "Empfängername",
    value: "customer_name",
    group: "Empfänger",
    description: "Fügt den Namen des angeschriebenen Ansprechpartners ein.",
    example: "Max Muster",
  },
  first_name: {
    name: "Vorname",
    label: "Vorname",
    value: "first_name",
    group: "Empfänger",
    description: "Fügt den Vornamen des angeschriebenen Ansprechpartners ein.",
    example: "Max",
  },
  last_name: {
    name: "Nachname",
    label: "Nachname",
    value: "last_name",
    group: "Empfänger",
    description: "Fügt den Nachnamen des angeschriebenen Ansprechpartners ein.",
    example: "Muster",
  },
  anrede: {
    name: "Anrede",
    label: "Anrede",
    value: "anrede",
    group: "Empfänger",
    description: "Fügt die gespeicherte Anrede oder den Anzeigenamen des Empfängers ein.",
    example: "Frau Muster",
  },
  appointment_sentence: {
    name: "Terminvorschlag",
    label: "Terminvorschlag",
    value: "appointment_sentence",
    group: "Termin",
    description:
      "Fügt einen ganzen Satz mit dem vorgeschlagenen Termin ein, wenn ein Termin bekannt ist.",
    example: "Unser Vorschlag ist am 22.06.2026 zwischen 08:45 und 09:45 Uhr.",
  },
  letter_work_intro_sentence: {
    name: "Arbeiten an der Liegenschaft",
    label: "Arbeiten an der Liegenschaft",
    value: "letter_work_intro_sentence",
    group: "Auftrag",
    description:
      "Fügt einen Satz ein, welche Schornsteinfegerarbeiten an welcher Liegenschaft anstehen.",
    example:
      "für Musterstraße 1, 12345 Musterstadt stehen Schornsteinfegerarbeiten vom Typ Feuerstättenschau an.",
  },
  appointment_slot_label: {
    name: "Terminzeit",
    label: "Terminzeit",
    value: "appointment_slot_label",
    group: "Termin",
    description: "Fügt Datum und Uhrzeit des bestätigten oder vorgeschlagenen Termins ein.",
    example: "22.06.2026, zwischen 08:45 und 09:45 Uhr",
  },
  previous_appointment_sentence: {
    name: "Bisheriger Termin entfällt",
    label: "Bisheriger Termin entfällt",
    value: "previous_appointment_sentence",
    group: "Termin",
    description:
      "Fügt bei einer Umplanung einen Satz ein, dass der bisherige Termin entfällt. In normalen Terminankündigungen bleibt dieser Platzhalter leer.",
    example: "Der bisherige Termin am 20.06.2026 zwischen 09:45 und 10:45 Uhr entfällt.",
  },
  response_sentence: {
    name: "Rückmeldesatz",
    label: "Rückmeldesatz",
    value: "response_sentence",
    group: "Termin",
    description: "Fügt die passende Bitte um Rückmeldung ein, bei Bedarf mit Frist.",
    example: "Bitte melden Sie sich zurück und bestätigen Sie diesen.",
  },
  public_link: {
    name: "Terminlink",
    label: "Terminlink",
    value: "public_link",
    group: "Links",
    description: "Fügt den persönlichen Link zur Terminabstimmung ein.",
    example: "https://app.kehrblatt.de/presentation/...",
  },
  link: {
    name: "Terminlink",
    label: "Terminlink",
    value: "link",
    group: "Links",
    description: "Fügt den persönlichen Link zur Terminabstimmung ein.",
    example: "https://app.kehrblatt.de/presentation/...",
  },
  confirm_link: {
    name: "Bestätigungslink",
    label: "Bestätigungslink",
    value: "confirm_link",
    group: "Links",
    description: "Fügt einen Link ein, über den der Empfänger den Terminvorschlag bestätigen kann.",
    example: "https://app.kehrblatt.de/presentation/...",
  },
  reschedule_link: {
    name: "Verschieben-Link",
    label: "Verschieben-Link",
    value: "reschedule_link",
    group: "Links",
    description: "Fügt einen Link ein, über den der Empfänger einen anderen Termin auswählen kann.",
    example: "https://app.kehrblatt.de/presentation/...",
  },
  cancel_link: {
    name: "Absage-Link",
    label: "Absage-Link",
    value: "cancel_link",
    group: "Links",
    description: "Fügt einen Link ein, über den der Empfänger den Termin absagen kann.",
    example: "https://app.kehrblatt.de/presentation/...",
  },
  mobile_public_link: {
    name: "Terminlink für SMS",
    label: "Terminlink für SMS",
    value: "mobile_public_link",
    group: "Links",
    description: "Fügt einen kurzen Terminlink ein, damit SMS nicht zu lang werden.",
    example: "https://app.kehrblatt.de/c/ABC12345",
  },
  mobile_appointment_cta: {
    name: "Aufforderung für SMS",
    label: "Aufforderung für SMS",
    value: "mobile_appointment_cta",
    group: "Links",
    description: "Fügt den kurzen Terminlink mit einer automatisch gekürzten Aufforderung ein.",
    example: "Bitte vereinbaren Sie den Termin: https://app.kehrblatt.de/c/ABC12345",
  },
  mobile_property_address: {
    name: "Adresse für SMS",
    label: "Adresse für SMS",
    value: "mobile_property_address",
    group: "Objekt",
    description: "Fügt die Liegenschaftsadresse in kurzer Form für SMS ein.",
    example: "Muenchner Str. 12",
  },
  mobile_appointment_proposal: {
    name: "Terminzeit für SMS",
    label: "Terminzeit für SMS",
    value: "mobile_appointment_proposal",
    group: "Termin",
    description: "Fügt den Terminvorschlag in kurzer Form für SMS ein.",
    example: "02.07. 08:45-09:45 Uhr",
  },
  order_number: {
    name: "Auftragsnummer",
    label: "Auftragsnummer",
    value: "order_number",
    group: "Auftrag",
    description: "Fügt die Auftragsnummer des Vorgangs ein.",
    example: "A-1042",
  },
  order_type_label: {
    name: "Auftragstyp",
    label: "Auftragstyp",
    value: "order_type_label",
    group: "Auftrag",
    description: "Öffentliche Bezeichnung des Auftragstyps bzw. der Auftragstypen",
    example: "Feuerstättenschau",
  },
  order_type_instruction: {
    name: "Auftragsaufforderung",
    label: "Auftragsaufforderung",
    value: "order_type_instruction",
    group: "Auftrag",
    description: "Aufforderungstext aus dem ersten gewählten Auftragstyp",
    example:
      "Bitte ermöglichen Sie Zugang zu allen Feuerstätten, Abgaswegen, Aufstellräumen und Reinigungsöffnungen.",
  },
  order_label: {
    name: "Auftragstyp",
    label: "Auftragstyp",
    value: "order_label",
    group: "Auftrag",
    description: "Fügt die Bezeichnung der Arbeiten ein, damit der Telefontext konkreter klingt.",
    example: "Feuerstättenschau",
  },
  address: {
    name: "Adresse",
    label: "Adresse",
    value: "address",
    group: "Objekt",
    description: "Fügt die Adresse der Liegenschaft für Telefontexte ein.",
    example: "Musterstraße 1, 12345 Musterstadt",
  },
  location: {
    name: "Ort",
    label: "Ort",
    value: "location",
    group: "Objekt",
    description: "Fügt den Ort der Liegenschaft für Telefontexte ein.",
    example: "Musterstadt",
  },
  location_suffix: {
    name: "Ortszusatz",
    label: "Ortszusatz",
    value: "location_suffix",
    group: "Objekt",
    description: "Fügt einen Ortszusatz ein, wenn ein Ort bekannt ist.",
    example: " in Musterstadt",
  },
} satisfies Record<string, TemplateTokenOption>

const aliasToken = (value: string, canonical: keyof typeof tokenCatalog): TemplateTokenOption => ({
  ...tokenCatalog[canonical],
  value,
  selectable: false,
})

const pickTokens = (
  values: (keyof typeof tokenCatalog | TemplateTokenOption)[],
): TemplateTokenOption[] =>
  values.map((entry) => (typeof entry === "string" ? tokenCatalog[entry] : entry))

export const templateTokenCatalog = Object.values(tokenCatalog)

const legacyRecipientAliases = [
  aliasToken("vorname", "first_name"),
  aliasToken("nachname", "last_name"),
]
const legacyAddressAliases = [
  aliasToken("adresse", "property_address"),
  aliasToken("adresse_ohne_land", "property_address_no_country"),
  aliasToken("adresse_ohne_deutschland", "property_address_no_country"),
  aliasToken("property_address_without_country", "property_address_no_country"),
]
const legacyLinkAliases = [aliasToken("link", "public_link")]
const legacyMobileLinkAliases = [aliasToken("mobile_link", "mobile_public_link")]
const orderInstructionAliases = [
  aliasToken("order_type_description", "order_type_instruction"),
  aliasToken("work_order_instruction", "order_type_instruction"),
  aliasToken("auftragsaufforderung", "order_type_instruction"),
]

export const emailSubjectTemplateTokens = pickTokens([
  "organization_name",
  "property_address_no_country",
  "appointment_slot_label",
  "customer_name",
  "order_number",
  ...legacyAddressAliases,
  ...legacyRecipientAliases,
])

export const emailBodyTemplateTokens = pickTokens([
  "letter_greeting",
  "property_address_no_country",
  "previous_appointment_sentence",
  "appointment_sentence",
  "appointment_slot_label",
  "organization_name",
  "organization_email",
  "organization_phone",
  "order_number",
  "order_type_label",
  "order_type_instruction",
  "customer_name",
  "confirm_link",
  "reschedule_link",
  "cancel_link",
  ...orderInstructionAliases,
  ...legacyAddressAliases,
  ...legacyRecipientAliases,
  ...legacyLinkAliases,
])

export const smsTemplateTokens = pickTokens([
  "mobile_appointment_proposal",
  "mobile_property_address",
  "mobile_appointment_cta",
  "mobile_public_link",
  "previous_appointment_sentence",
  ...legacyAddressAliases,
  ...legacyRecipientAliases,
  ...legacyMobileLinkAliases,
])

export const phoneTemplateTokens = pickTokens([
  "organization_name",
  "customer_name",
  "address",
  "order_label",
  aliasToken("location", "location"),
  aliasToken("location_suffix", "location_suffix"),
])

const letterTemplateTokenValues: (keyof typeof tokenCatalog | TemplateTokenOption)[] = [
  "letter_greeting",
  "property_address_no_country",
  "letter_work_intro_sentence",
  "appointment_sentence",
  "order_type_label",
  "order_type_instruction",
  "organization_name",
  "service_number",
  "service_email",
  "order_number",
  ...orderInstructionAliases,
  ...legacyAddressAliases,
  ...legacyRecipientAliases,
  ...legacyLinkAliases,
  aliasToken("response_sentence", "response_sentence"),
]

export const letterTemplateTokens = pickTokens(letterTemplateTokenValues)
export const letterSubtitleTemplateTokens = pickTokens(["order_type_label", "target_unit_phrase"])
export const letterPortalHeadingTemplateTokens = pickTokens(["response_deadline_phrase"])
export const letterRescheduleTemplateTokens = pickTokens([
  ...letterTemplateTokenValues,
  "previous_appointment_sentence",
])

export const templateTokens = emailBodyTemplateTokens

export const TEMPLATE_HELPER_TEXT =
  "Über + können Sie Platzhalter einfügen. Die gespeicherte Vorlage bleibt kompatibel."
export const PHONE_TEMPLATE_HELPER_TEXT = TEMPLATE_HELPER_TEXT
export const LETTER_TEMPLATE_HELPER_TEXT = TEMPLATE_HELPER_TEXT

export const MOBILE_MESSAGE_SINGLE_SEGMENT_LIMIT = 160
export const SMS_SINGLE_SEGMENT_LIMIT = MOBILE_MESSAGE_SINGLE_SEGMENT_LIMIT
const LEGACY_CTA_DEFAULT_MOBILE_MESSAGE_TEMPLATE =
  "Der Kaminkehrer kommt am {mobile_appointment_proposal} fuer {mobile_property_address}. Bitte vereinbaren Sie den Termin: {mobile_public_link}"
const LEGACY_CTA_DEFAULT_MOBILE_MESSAGE_RESCHEDULE_TEMPLATE =
  "Ihr Kaminkehrertermin wurde verschoben auf {mobile_appointment_proposal} fuer {mobile_property_address}. Bitte vereinbaren Sie den Termin: {mobile_public_link}"
const LEGACY_COMPACT_DEFAULT_MOBILE_MESSAGE_TEMPLATE =
  "Zeitfenster {mobile_appointment_proposal}: {mobile_public_link}"
const LEGACY_WINDOW_ADDRESS_DEFAULT_MOBILE_MESSAGE_TEMPLATE =
  "Zeitfenster {mobile_appointment_proposal} fuer {mobile_property_address}. Bitte vereinbaren: {mobile_public_link}"
export const DEFAULT_MOBILE_MESSAGE_TEMPLATE =
  "Der Kaminkehrer kommt am {mobile_appointment_proposal} fuer {mobile_property_address}. {mobile_appointment_cta}"
export const DEFAULT_MOBILE_MESSAGE_RESCHEDULE_TEMPLATE =
  "Ihr Kaminkehrertermin wurde verschoben auf {mobile_appointment_proposal} fuer {mobile_property_address}. {mobile_appointment_cta}"
const LEGACY_UMLAUT_DEFAULT_MOBILE_MESSAGE_TEMPLATE =
  "Der Kaminkehrer kommt am {mobile_appointment_proposal} fuer {mobile_property_address}. Bitte bestätigen Sie den Termin: {mobile_public_link}"
export const LEGACY_DEFAULT_MOBILE_MESSAGE_TEMPLATE =
  "Termin {mobile_appointment_proposal} fuer {mobile_property_address}: {mobile_public_link}"
export const LEGACY_SMS_DEFAULT_MOBILE_MESSAGE_TEMPLATE =
  "{organization_name}: Schornsteinfegertermin für {property_address_no_country} abstimmen: {public_link}"
const KNOWN_DEFAULT_MOBILE_MESSAGE_TEMPLATES = [
  DEFAULT_MOBILE_MESSAGE_TEMPLATE,
  LEGACY_CTA_DEFAULT_MOBILE_MESSAGE_TEMPLATE,
  LEGACY_COMPACT_DEFAULT_MOBILE_MESSAGE_TEMPLATE,
  LEGACY_WINDOW_ADDRESS_DEFAULT_MOBILE_MESSAGE_TEMPLATE,
  LEGACY_UMLAUT_DEFAULT_MOBILE_MESSAGE_TEMPLATE,
  LEGACY_DEFAULT_MOBILE_MESSAGE_TEMPLATE,
  LEGACY_SMS_DEFAULT_MOBILE_MESSAGE_TEMPLATE,
  DEFAULT_MOBILE_MESSAGE_RESCHEDULE_TEMPLATE,
  LEGACY_CTA_DEFAULT_MOBILE_MESSAGE_RESCHEDULE_TEMPLATE,
]
export const SMS_TEMPLATE_VARIABLE_BUDGETS: Record<string, number> = {
  organization_name: 32,
  property_address_no_country: 48,
  property_address_without_country: 48,
  adresse_ohne_land: 48,
  adresse_ohne_deutschland: 48,
  property_address: 56,
  adresse: 56,
  public_link: 56,
  link: 56,
  mobile_public_link: 56,
  mobile_link: 56,
  mobile_appointment_cta: 92,
  mobile_property_address: 56,
  mobile_appointment_proposal: 44,
  previous_appointment_sentence: 48,
  customer_name: 24,
  anrede: 24,
  first_name: 16,
  vorname: 16,
  last_name: 20,
  nachname: 20,
  order_number: 16,
}
const TEMPLATE_VARIABLE_PATTERN = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}|\{\s*([a-zA-Z0-9_]+)\s*\}/g
const WHITESPACE_PATTERN = /\s+/g

export const estimateTemplateLength = (value: string) => {
  let total = 0
  let lastIndex = 0
  for (const match of value.matchAll(TEMPLATE_VARIABLE_PATTERN)) {
    const start = match.index ?? 0
    total += value.slice(lastIndex, start).length
    const variableName = String(match[1] || match[2] || "").trim()
    total += SMS_TEMPLATE_VARIABLE_BUDGETS[variableName] ?? Math.max(variableName.length, 16)
    lastIndex = start + match[0].length
  }
  total += value.slice(lastIndex).length

  return total
}

export const normalizeTemplateForComparison = (value: unknown) =>
  String(value ?? "")
    .replace(WHITESPACE_PATTERN, " ")
    .trim()

export const isDefaultMobileMessageTemplate = (value: string) => {
  const normalized = normalizeTemplateForComparison(value)

  return KNOWN_DEFAULT_MOBILE_MESSAGE_TEMPLATES.some(
    (template) => normalizeTemplateForComparison(template) === normalized,
  )
}

export const buildSmsLengthMessage = (value: string) => {
  const estimatedLength = estimateTemplateLength(value)
  const defaultTemplate = isDefaultMobileMessageTemplate(value)
  const withinLimit = defaultTemplate || estimatedLength <= SMS_SINGLE_SEGMENT_LIMIT
  const base = `Geschaetzte Laenge der mobilen Nachricht: ${estimatedLength}/${SMS_SINGLE_SEGMENT_LIMIT} Zeichen. Laengere Nachrichten werden aus Kostenschutz nicht versendet.`

  if (defaultTemplate) {
    return {
      estimatedLength,
      withinLimit,
      defaultTemplate,
      helperText: `${base} Bei unveraenderter Standardvorlage wird der Bestaetigungs-Hinweis bei Bedarf automatisch gekuerzt.`,
    }
  }

  return {
    estimatedLength,
    withinLimit,
    defaultTemplate,
    helperText: withinLimit
      ? base
      : `${base} Bitte kuerzen, damit die Vorlage innerhalb des Limits bleibt.`,
  }
}
